import React from 'react';
import { Accent, accentIcon, accentBorderHover } from '../lib/accents';

export const ValueCard: React.FC<{ title: string; description: string; children: React.ReactNode; accent?: Accent }> = ({ title, description, children, accent = 'primary' }) => (
    <div className={`h-full bg-card p-8 rounded-lg border border-border text-center flex flex-col items-center hover:shadow-lg ${accentBorderHover[accent]} transition-all duration-300 transform hover:-translate-y-1`}>
        <div className={`flex-shrink-0 ${accentIcon[accent]} p-4 rounded-full mb-4`}>
            {children}
        </div>
        <h4 className="text-lg font-bold text-foreground font-heading">{title}</h4>
        <p className="text-muted-foreground mt-1 flex-grow">{description}</p>
    </div>
);